var _path, _path2, _use, _use2, _use3, _use4, _use5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuildlabOpenai(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2406 2406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 578.4C1 259.5 259.5 1 578.4 1h1249.1c319 0 577.5 258.5 577.5 577.4V2406H578.4C259.5 2406 1 2147.5 1 1828.6V578.4z",
    fill: "#74aa9c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1107.3 299.1c-197.999 0-373.9 127.3-435.2 315.3L650 743.5v427.9c0 21.4 11 40.4 29.4 51.4l344.5 198.515V833.3h.1v-27.9L1372.7 604c33.715-19.52 70.44-32.857 108.47-39.828L1447.6 450.3C1361 353.5 1237.1 298.5 1107.3 299.1zm0 117.5-.6.6c79.699 0 156.3 27.5 217.6 78.4-2.5 1.2-7.4 4.3-11 6.1L952.8 709.3c-18.4 10.4-29.4 30-29.4 51.4V1248l-155.1-89.4V755.8c-.1-187.099 151.601-338.9 339-339.2z",
    fill: "#fff"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "rotate(60 1203 1203)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "rotate(120 1203 1203)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "rotate(180 1203 1203)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "rotate(240 1203 1203)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    href: "#a",
    transform: "rotate(300 1203 1203)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildlabOpenai);
export default __webpack_public_path__ + "static/media/buildlab_openai.3ced682a2c62ccaacbecc4f5a0e2e1c5.svg";
export { ForwardRef as ReactComponent };